
import {getSupportList} from '../api/getSupportList';
import {setGetSupportListAction} from '../action';

const setGetSupportList = (params) => {
    return async (dispatch, getState) => {
        try {
   
            const {data} = await getSupportList(params);
     
            if (data.status === 'success') {
                dispatch(setGetSupportListAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetSupportList
}